import { render, staticRenderFns } from "./gptOil.vue?vue&type=template&id=bf242bea&scoped=true"
import script from "./gptOil.vue?vue&type=script&lang=js"
export * from "./gptOil.vue?vue&type=script&lang=js"
import style0 from "./gptOil.vue?vue&type=style&index=0&id=bf242bea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf242bea",
  null
  
)

export default component.exports